export const kpiData = [
  {name: 'ValidationSpeed', type: 1, translationKey: 'debtor.dashboard.kpis.validationScore'},
  {name: 'ResponsivenessScore', type: 1, translationKey: 'confirming.dashboard.kpis.responsivenessScore'}
];
